import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { OfferDetailsService } from '../../services/offer-details/offer-details.service';
import { UntypedFormGroup, Validators, UntypedFormControl, FormGroup, FormControl } from '@angular/forms';
import { FilesService } from 'src/app/services/shared/files/files.service';
import { NotificationService } from 'src/app/services/shared/notification/notification.service';
import { getInvalidFields, getInvalidFieldsV2, jsonDeepParse, prepareFieldConfigFlagsNew } from 'src/app/functions/shared-functions';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { ConfirmationComponent } from '../../../shared/confirmation/confirmation.component';
import { MatDialog } from '@angular/material/dialog';
import { getIP } from 'src/app/modules/jobseeker-registration/services/registration/jobseeker-registration.service';
import { environment } from 'src/environments/environment';
import { NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { ProfileSettingsService } from 'src/app/services/shared/profile-settings/profile-settings.service';

@Component({
  selector: 'app-offer-details',
  templateUrl: './offer-details.component.html',
  styleUrls: ['./offer-details.component.scss'],
  providers: [OfferDetailsService, FilesService]
})
export class OfferDetailsComponent implements OnInit, AfterViewInit {

  @Output() formSaved = new EventEmitter();
  @Input() disable_action;
  @Input() first_login_details;
  @Input() type;
  activeTab = 1;
  terms_conditions = false;
  error_message;
  submitOfferAcceptanceApiCallRef = this.reloadPage.bind(this);
  form_details: FormGroup = new FormGroup({

  });
  // session = new Session();
  sign_upload_type = 1;
  verificationObj = {}
  offer_details;
  field_config_access: any = {};
  uploading_status = true;

  constructor(public offer_details_srv: OfferDetailsService,
    private notification: NotificationService,
    private dialog: MatDialog,
    private file_srv: FilesService,
    private translate: TranslateService,
    private change_detector: ChangeDetectorRef,
    private profile_settings_srv: ProfileSettingsService
  ) {

  }
  ngAfterViewInit(): void {


  }

  navChange(ev) {

    if (this.activeTab == 1) {

    }

  }
  reset_embed_tag = true;

  digital_signature_form = new UntypedFormGroup({
    signature: new UntypedFormControl(null, [Validators.required]),
    candidateJoiningDate: new UntypedFormControl(null),
    signedAttachLetter: new FormControl(null),
    offerDeclineNotes: new FormControl(null)
  })
  signed_url;

  valid_captcha
  valid_captcha_flag = false;
  showOfferAcceptanceDocumentation = 0;
  @ViewChild('recaptcha', { static: true }) captch_element: ElementRef;



  ngOnInit() {


    this.profile_settings_srv.loadDefaultSettings().subscribe(res => {
      if (res && res['data']) {

        if (res['data'].fieldConfigFlags) {
          this.field_config_access = prepareFieldConfigFlagsNew(res['data'].fieldConfigFlags, null, null, "CAREERS_");
          console.log(this.field_config_access)
        }
      }
    })


    if (this.type == 6) {
      this.getOfferAcceptanceDeatils();
    }
    else {
      this.getOfferDetails();
    }




  }
  loading = false;
  contentLoaded() {
    this.loading = false;
    console.log('Doc loaded')
  }
  reloading(ev) {
    console.log(ev)
  }

  getOfferDetails() {
    this.offer_details_srv.getOfferDetails().subscribe(res => {


      if (res && res['status']) {
        this.offer_details = jsonDeepParse(res['data']);
        if (this.offer_details['manualAcceptance']) {
          this.digital_signature_form.controls.signedAttachLetter.setValidators([Validators.required]);
          this.digital_signature_form.controls.signedAttachLetter.updateValueAndValidity();
          this.digital_signature_form.controls.signature.clearValidators();
          this.digital_signature_form.controls.signature.updateValueAndValidity();
        }
        this.disable_action = this.offer_details.offerAcceptance == 0 ? 1 : 0;
        if (this.type == 6) {
          this.offer_details.showOfferAcceptanceDocumentation = 1;

          if (this.offer_details.showOfferAcceptanceDocumentation) {
            this.getOfferAcceptanceDeatils()
          }
        }
        if (!this.type) {
          setTimeout(() => {
            if (!this.disable_action) {
              this.addRecaptchaScript()
            }
          })
          if (this.disable_action && this.offer_details && this.offer_details.offerAcceptedSignature) {
            let sign;
            if (this.offer_details.offerAcceptedSignature && this.offer_details.offerAcceptedSignature.length && typeof this.offer_details.offerAcceptedSignature == 'object') {
              sign = this.offer_details.offerAcceptedSignature
            }
            else if (this.offer_details.offerAcceptedSignature && typeof this.offer_details.offerAcceptedSignature == 'object') {
              sign = [this.offer_details.offerAcceptedSignature];
            }

            if (sign) {
              this.digital_signature_form.get('signature').patchValue(sign);
            }
          }
          this.file_srv.getURL(this.offer_details.cdnPath).subscribe(res => {
            if (res && res['data']) {
              this.signed_url = res['data'].url;
              this.loading = true;

            }
          })
        }



        if (res['data'].detail) {
          this.form_details = jsonDeepParse(res['data'].detail);
          this.verificationObj = res['data'].detail.verificationStatus || {};
        }
        // this.getBase64(this.offer_details.cdnPath, this.offer_details)
      }
      else {
        this.error_message = res['message']
      }
    })
  }

  getOfferAcceptanceDeatils() {
    this.offer_details_srv.getPreOfferDetails({ type: 6 }).subscribe(res => {
      if (res && res['data'] && res['status']) {
        if (res['data'].detail) {
          this.form_details = jsonDeepParse(res['data'].detail);
          this.verificationObj = res['data'].detail.verificationStatus || {};
          this.disable_action = res['data']?.detail?.lockPostOfferDocFlag ? true : false;
        }
      }
    })
  }

  toggleSignatureType() {
    this.digital_signature_form.reset()
    if (this.sign_upload_type == 1) {
      this.sign_upload_type = 2;
    }
    else if (this.sign_upload_type == 2) {
      this.sign_upload_type = 1;
    }
  }

  getBase64(cdnPath, file) {

    this.reset_embed_tag = false;
    this.file_srv.getDocxBase64(cdnPath).subscribe(res => {

      if (res && res['data']) {
        console.log(res['data'])
        file.fileData = 'data:application/pdf;base64,' + res['data'].filedata;
        setTimeout(() => {
          this.reset_embed_tag = true;
        })
      }
    })
  }


  termsConditions() {

  }

  submitOfferAcceptance(e) {
    if (this.valid_captcha_flag && this.uploading_status) {
      if (e == 1) {
        if (!this.terms_conditions) {
          this.notification.error('Please accept the terms', 'close', 3000);

          return false;
        }

        if (this.digital_signature_form.invalid) {
          // this.notification.error('your signature', 'close', 3000);
          getInvalidFieldsV2(this.digital_signature_form, this.translate, this.notification, 'OFFER.', null, this.field_config_access, 'CAREERS_')
          return false;
        }
      }
      this.dialog.open(ConfirmationComponent, {
        width: "480px",
        height: "auto",
        panelClass: "icr-dialog",
        data: {
          title: "ERROR.confirmation",
          message: "OFFER.are_you_sure_to_proceed",
          positive_button: "BTN.yes",
          negative_button: "BTN.no",
          enableNotes: e == 2 ? 1 : null,
          notesLabel: e == 2 ? this.field_config_access?.['CAREERS_offerDeclineNotes']?.label || 'Reason for decline' : null,
          notesPlaceholder: e == 2 ? this.field_config_access?.['CAREERS_offerDeclineNotes']?.placeholder || 'Enter reason for decline' : null
        },
      }).afterClosed().subscribe((action) => {
        if (action) {
          this.digital_signature_form.controls.offerDeclineNotes.patchValue(action.notes)
          this.submitOfferAcceptanceApiCall(e)

          // if (this.offer_details && this.offer_details.showOfferAcceptanceDocumentation && e == 1) {
          //   this.activeTab = 2;
          // }
          // else {
          //   this.submitOfferAcceptanceApiCall(e)
          // }
        }
      })
    }
    else {
      if (!this.uploading_status) {
        this.notification.error('ERROR.please_wait_while_attachments_being_uploaded', 'Close', 5000);
        return;
      }
      this.notification.error('ERROR.verify_captcha', 'Close', 5000)
    }
  }

  onNavChange(changeEvent: NgbNavChangeEvent) {
    if (!this.disable_action) {
      if (this.valid_captcha_flag) {
        if (!this.terms_conditions) {
          this.notification.error('Please accept the terms', 'close', 3000);
          changeEvent.preventDefault();
        }

        if (this.digital_signature_form.invalid) {
          // this.notification.error('your signature', 'close', 3000);
          getInvalidFields(this.digital_signature_form, this.translate, this.notification, 'OFFER.');
          changeEvent.preventDefault();
        }
      }
      else {
        changeEvent.preventDefault();
        this.notification.error('ERROR.verify_captcha', 'Close', 5000)
      }
    }
  }

  reloadPage() {
    location.reload();
  }
  submitOfferAcceptanceApiCall(e) {
    try {
      this.uploadSign(this.sign_upload_type).subscribe(res => {
        let offerAcceptedSignature = this.sign_upload_type == 1 ? (res ? res : null) : this.digital_signature_form.value.signature
        let ip
        try {
          ip = getIP().ip;
        } catch (error) {

        }

        let save_obj =
        {
          offerId: this.offer_details.offerId,
          status: e,
          offerAcceptedSignature: offerAcceptedSignature,
          offerIP: ip ? ip : '',
          candidateJoiningDate: this.digital_signature_form.value.candidateJoiningDate || null,
          signedAttachLetter: this.digital_signature_form.value.signedAttachLetter,
          offerDeclineNotes: this.digital_signature_form.value.offerDeclineNotes
        }
        console.log(save_obj)
        this.offer_details_srv.submitOfferAcceptance(save_obj).subscribe(res => {



          if (res && res['status']) {
            this.notification.success(res['message'], 'close', 5000);
            this.formSaved.emit('true');
            location.reload();
          }
          else {
            this.notification.error(res['message'], 'close', 5000);

          }
          // this.router.navigate(['/my-jobs']);
        })
      })
      //offerAcceptedSignature: this.digital_signature_form.value.signature

    }
    catch (err) {

      console.log(err)
    }
  }

  get getLocalIPAddress() {
    return getIP().ip;
  }


  uploadSign(type) {
    return new Observable(obs => {
      if (type == 1 && !this.offer_details?.['manualAcceptance']) {
        let file = this.dataURLtoFile(this.digital_signature_form.value.signature, 'digital-sign.png')
        let form_data = new FormData();
        form_data.append('attachment', file, file.name);
        this.notification.success('FILES.uploading_attachments', 'Close', 3000);
        this.file_srv.uploadAttachment(form_data).subscribe(res => {

          let attach = {}
          if (res && res['data']) {

            attach['fileName'] = res['data']['a_fn'];
            attach['cdnPath'] = res['data']["a_url"];
            this.notification.success(res['message'], 'Close', 3000);
            obs.next(attach)
            // attach['width'] = this.result_dimentions[0].width
            // attach['height'] = this.result_dimentions[0].heigh
          }
          else {
            obs.next(0)
            this.notification.error(res && res['message'], 'Close', 3000);
          }
        }, err => {
          obs.next(0);
        })
      }
      else if (type == 2) {
        obs.next(1)
      }
      else {
        obs.next(1)
      }
    })

  }

  dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  addRecaptchaScript() {

    window['grecaptchaCallback'] = () => {
      this.renderReCaptch();
    }

    (function (d, s, id, obj) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { obj.renderReCaptch(); return; }
      js = d.createElement(s); js.id = id;
      js.src = "https://www.google.com/recaptcha/api.js?onload=grecaptchaCallback&amp;render=explicit";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'recaptcha-jssdk', this));
  }
  renderReCaptch() {
    try {
      window['grecaptcha'].render('tm-recaptcha', {
        'sitekey': environment.RECAPCHA_KEY,
        'callback': (response) => {
          this.valid_captcha = response;
          this.valid_captcha_flag = true;
          this.change_detector.detectChanges();
        },
        'expired-callback': (response) => {
          this.expiredCallback();
        },
      });
    }
    catch (err) {
      try {
        setTimeout(() => {
          window['grecaptcha'].render('tm-recaptcha', {
            'sitekey': environment.RECAPCHA_KEY,
            'callback': (response) => {
              this.valid_captcha = response;
              this.valid_captcha_flag = true;
              this.change_detector.detectChanges();
            },
            'expired-callback': (response) => {
              this.expiredCallback();
            },
          });
        }, 200)
      }
      catch (err) {
        setTimeout(() => {
          window['grecaptcha'].render('tm-recaptcha', {
            'sitekey': environment.RECAPCHA_KEY,
            'callback': (response) => {
              this.valid_captcha = response;
              this.valid_captcha_flag = true;
              this.change_detector.detectChanges();
            },
            'expired-callback': (response) => {
              this.expiredCallback();
            },
          });
        }, 200)
      }
    }

  }
  expiredCallback() {
    this.valid_captcha = "";
    this.valid_captcha_flag = false
    this.change_detector.detectChanges();

  }
  uploadedStatus(ev) {
    this.uploading_status = ev;
  }
}
